import React, { Suspense } from 'react';

/**
 * 组件懒加载包装函数
 * @param {Function} importComponent - 动态导入组件的函数
 * @param {React.Component} LoadingComponent - 加载中显示的组件
 * @returns {React.Component} - 懒加载的组件
 */
export const lazyLoad = (importComponent, LoadingComponent = null) => {
  const LazyComponent = React.lazy(importComponent);

  return (props) => (
    <Suspense fallback={LoadingComponent || <div>加载中...</div>}>
      <LazyComponent {...props} />
    </Suspense>
  );
}; 